import { AppConfigurationClient } from "@azure/app-configuration";

const connectionString =
    "Endpoint=https://dbot-configurations.azconfig.io;Id=MtUM;Secret=5O6rlrYBJy6sqQhod9u61t7MdXsMHECxpHnmFtOpaRdVBwfoeVx7JQQJ99AJACYeBjFr4wI3AAACAZACprOO";

export async function isCustomToolsFeatureEnabled() {
    try {
        const client = new AppConfigurationClient(connectionString);
        const featureFlagKey = ".appconfig.featureflag/CustomTools";

        const setting = await client.getConfigurationSetting({ key: featureFlagKey });
        if (!setting?.value) {
            // console.warn("CustomTools feature flag not found or has no value.");
            return false;
        }
        const flagConfig = JSON.parse(setting.value);
        return !!flagConfig.enabled;
    } catch (error) {
        // console.error("Error fetching CustomTools feature flag:", error);
        return false;
    }
}
